class Rule {
  constructor (attrs) {
    this.id = attrs.id
    this.identityId = attrs.identityId
    this.pattern = attrs.pattern || ''
    this.payee = attrs.payee || ''
    this.category = attrs.category || ''
    this.sourceIds = attrs.sourceIds || []
  }

  appliesTo (sourceId) {
    return this.sourceIds.length === 0 || this.sourceIds.includes(sourceId)
  }
}

export default Rule
